import { useEffect } from "react";
import api from "@/lib/api";

const KEY = "budget_notif_v1";

const fire = async (title, opts) => {
  try {
    const reg = await (navigator.serviceWorker?.ready || Promise.reject());
    return reg.showNotification(title, opts);
  } catch {
    try { new Notification(title, opts); } catch { /* ignore */ }
  }
};

export function useBudgetNotifier(lang = "en") {
  useEffect(() => {
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/budgets");
        if (cancelled || !Array.isArray(data)) return;
        const today = new Date().toDateString();
        let stored = {};
        try { stored = JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { /* ignore */ }
        const next = { ...stored };
        for (const b of data) {
          if (b.status === "ok") continue;
          const k = `${b.status}_${today}`;
          if (stored[b.category] === k) continue;
          const icon = b.status === "blocked" ? "🚫" : "⚠️";
          const title = `${icon} My Expenses`;
          const body = lang === "ar"
            ? `${b.category} — ${b.percent}% من الميزانية`
            : `${b.category} — ${b.percent}% of monthly budget used`;
          const opts = { body, icon: "/icons/icon-192.png", badge: "/icons/icon-192.png", tag: `budget-${b.category}`, renotify: true, lang };
          await fire(title, opts);
          next[b.category] = k;
        }
        try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* ignore */ }
      } catch { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, [lang]);
}
